<template>
  <div class="features" v-once>
    <div class="container">
      <el-row type="flex" justify="center">
        <h6>Top Features</h6>
      </el-row>
      <el-row type="flex" justify="center">
        <h3>Protect your portfolio like never before.</h3>
      </el-row>
      <el-row :gutter="20">
        <el-col :md="8">
          <img src="~/assets/icons/fully-automated.svg">
          <p><strong>Fully Automated.</strong> Sit back, relax, and watch your bags being busted.</p>
        </el-col>
        <el-col :md="8">
          <img src="~/assets/icons/quick-setup.svg">
          <p><strong>Quick Setup.</strong> PTDefender is ready to bust some bags in less than 10 minutes.</p>
        </el-col>
        <el-col :md="8">
          <img src="~/assets/icons/ease-of-use.svg">
          <p><strong>Ease of Use.</strong> Built around the best user experience possible.</p>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :md="8">
          <img src="~/assets/icons/select-your-coins.svg">
          <p><strong>Select Your Coins.</strong> Free range to select which coins you want to use this strategy on.</p>
        </el-col>
        <el-col :md="8">
          <img src="~/assets/icons/recalculation.svg">
          <p><strong>Automatic Recalculation.</strong> Adjusts your buy and sell quantities after each round.</p>
        </el-col>
        <el-col :md="8">
          <img src="~/assets/icons/security.svg">
          <p><strong>Secure.</strong> All data is end-to-end encrypted and stored in a secure VPC on AWS.</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Features'
}
</script>

<style lang="scss">
.features {
  padding: 60px 0;

  h3, h6 {
    text-align: center;
  }

  h3 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 20px;
  }

  h6 {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
    opacity: 0.5;
    margin-bottom: 4px;
  }

  img {
    width: 80%;
    display: block;
    margin: 0 auto;
  }
}
</style>
